import { API, graphqlOperation } from "aws-amplify"
import { onNewAppVersion } from "../../../graphql/postgress_graphql/subscriptions";
import { Observable } from 'zen-observable-ts';
import { AppVersion } from "../../../types";

type SubscriptionCallbacks = {
    onNext?: (data: AppVersion) => void;
    onError?: (error: any) => void;
}
type AppVersionSubscriptionResult = {
  value: {
    data: {
      onNewAppVersion: AppVersion;
    };
  };
};

let subscription: any;
export const subscribeAppVersion = async ({ onNext = () => { }, onError = () => { } }: SubscriptionCallbacks) => {
    subscription = (API.graphql(
        graphqlOperation(onNewAppVersion)
    ) as Observable<any>).subscribe({
        next: (data: AppVersionSubscriptionResult) => {
            console.log(data)
            onNext(data.value.data.onNewAppVersion)
        },
        error: (error: any) => {
            onError(error)
            console.log(error)
        },
    });
    return subscription
}

export const unsubscribeAppVersion = (): void => {
    if (subscription) {
        subscription.unsubscribe();
    }
}
